function translate(key, fallback, variables = {}) {
  const helper = globalThis.window?.__fishystuffLanguage;
  if (!key || typeof helper?.t !== "function") {
    return fallback;
  }
  const value = helper.t(key, variables);
  return !value || value === key ? fallback : value;
}

function text(value) {
  return { kind: "text", text: String(value) };
}

function propertyNames(change) {
  return (Array.isArray(change?.pathSegments) ? change.pathSegments : [])
    .filter((segment) => segment?.kind === "property")
    .map((segment) => String(segment.name));
}

function arrayIndex(change) {
  const segment = (Array.isArray(change?.pathSegments) ? change.pathSegments : [])
    .find((candidate) => candidate?.kind === "index");
  return Number.isSafeInteger(segment?.index) ? segment.index : null;
}

function fishName(itemId, root) {
  if (!Number.isSafeInteger(itemId) || itemId <= 0) {
    return "";
  }
  const card = root?.querySelector?.(`[data-fish-id="${itemId}"]`) ?? null;
  const visibleName = String(
    card?.querySelector?.(".fishydex-name, .fishy-item-label")?.textContent ?? "",
  ).replace(/\s+/g, " ").trim();
  return visibleName || translate("domain.entity.fish_id", `Fish ${itemId}`, { id: itemId });
}

function membershipValue(field, present) {
  if (field === "caughtIds") {
    return text(present
      ? translate("fishydex.details.caught", "Caught")
      : translate("fishydex.details.not_caught", "Not Caught"));
  }
  return text(present
    ? translate("fishydex.details.favourite", "Favourite")
    : translate("fishydex.presets.change.not_favourite", "Not favourite"));
}

function presentMembership(change, field, root) {
  const savedId = Number.isSafeInteger(change.savedValue) ? change.savedValue : null;
  const workingId = Number.isSafeInteger(change.workingValue) ? change.workingValue : null;
  const fieldName = field === "caughtIds"
    ? translate("fishydex.presets.change.caught_fish", "Caught fish")
    : translate("fishydex.presets.change.favourite_fish", "Favourite fish");
  const signalField = `_shared_fish.${field}`;
  if (savedId !== null && workingId !== null && savedId !== workingId) {
    return {
      name: fieldName,
      signalKey: `${signalField}[${arrayIndex(change) ?? "?"}]`,
      oldValue: text(fishName(savedId, root)),
      newValue: text(fishName(workingId, root)),
    };
  }
  const itemId = savedId ?? workingId;
  return {
    name: `${fieldName} · ${fishName(itemId, root)}`,
    signalKey: `${signalField}[${itemId}]`,
    oldValue: membershipValue(field, change.savedPresent),
    newValue: membershipValue(field, change.workingPresent),
  };
}

export function presentFishydexPresetChange(change, root = globalThis.document) {
  const names = propertyNames(change);
  const field = names[0];
  if (field === "caughtIds" || field === "favouriteIds") {
    return presentMembership(change, field, root);
  }
  if (field === "showDried") {
    return {
      name: translate("fishydex.presets.change.dried_visibility", "Dried fish visibility"),
      signalKey: "show_dried",
      oldValue: text(change.savedValue === true
        ? translate("fishydex.presets.change.shown", "Shown")
        : translate("fishydex.presets.change.hidden", "Hidden")),
      newValue: text(change.workingValue === true
        ? translate("fishydex.presets.change.shown", "Shown")
        : translate("fishydex.presets.change.hidden", "Hidden")),
    };
  }
  return null;
}
